import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";

import {
  successAddVideoUpload,
  failureAddVideoUpload,
} from "./AddVideoUploadSlice";

import {
  successDeleteVideoUpload,
  failureDeleteVideoUpload,
} from "./DeleteVideoUploadSlice";

import {
  successListVideoUpload,
  failureListVideoUpload,
} from "./ListVideoUploadSlice";

import {
  successEditVideoUpload,
  failureEditVideoUpload,
} from "./EditVideoUploadSlice";

import { VideoLessonUploadForm } from "../../../Pages/VideoLessons/Ivideolessons";
import {
  failurelistTopicSectionVideo,
  successlistTopicSectionVideo,
} from "./ListTopicSectionVideoSlice";

// Define a type with the video lesson structure (including ID for edit)
type IVideoLesson = {
  id: number;
} & VideoLessonUploadForm;

// --------------------- List ---------------------
const ListVideoLessonApi = () => {
  return api.get("/api/video/");
};

export function* ListVideoLessonCall() {
  try {
    console.log("previous called");
    const response: AxiosResponse = yield call(ListVideoLessonApi);
    yield put(successListVideoUpload(response.data));
  } catch (error) {
    yield put(failureListVideoUpload(error));
  }
}
//drop down list
const ListTopicSectionVideo = () => {
  return api.get("/api/video/topic/list");
};

export function* ListTopicSectionVideoCall() {
  try {
    console.log("called");
    const response: AxiosResponse = yield call(ListTopicSectionVideo);
    yield put(successlistTopicSectionVideo(response.data));
  } catch (error) {
    yield put(failurelistTopicSectionVideo(error));
  }
}

// --------------------- Add ---------------------
const AddVideoLessonApi = (formData: FormData) => {
  return api.post("/api/video/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export function* AddVideoLessonCall(
  action: PayloadAction<VideoLessonUploadForm>
) {
  try {
    const { topic_id, title, description, language, status, file ,free_tier} =
      action.payload;
    const formData = new FormData();

    formData.append("topic_id", topic_id.toString());
    formData.append("title", title);
    formData.append("description", description ?? "");
    formData.append("language", language);
    formData.append("status", status.toString());
    formData.append("free_tier", free_tier ? "1" : "0");

    if (file) {
      formData.append("file", file);
    }

    const response: AxiosResponse = yield call(AddVideoLessonApi, formData);
    yield put(successAddVideoUpload(response.data));
  } catch (error) {
    yield put(failureAddVideoUpload(error));
  }
}

// --------------------- Edit ---------------------
// API call
// API call
const EditVideoLessonApi = (formData: FormData, id: number) => {
  return api.put("/api/video/update", formData, {
    params: { id }, 
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Saga
export function* EditVideoLessonCall(action: PayloadAction<IVideoLesson>) {
  try {
    const { id, topic_id, title, description, language, status, file,free_tier } =
      action.payload;

    const formData = new FormData();
    formData.append("topic_id", topic_id.toString());
    formData.append("title", title);
    formData.append("description", description ?? "");
    formData.append("language", language);
    formData.append("status", status.toString());
    formData.append("free_tier", free_tier ? "1" : "0");

    if (file) {
      formData.append("file", file); // only append if user uploaded a new file
    }

    const response: AxiosResponse = yield call(EditVideoLessonApi, formData, id);
    yield put(successEditVideoUpload(response.data));
  } catch (error) {
    yield put(failureEditVideoUpload(error));
  }
}



// --------------------- Delete ---------------------
const DeleteVideoLessonApi = (id: number) => {
  return api.delete("/api/video/delete", {
    params: { id },
  });
};

export function* DeleteVideoLessonCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(
      DeleteVideoLessonApi,
      action.payload
    );
    yield put(successDeleteVideoUpload(response.data));
  } catch (error) {
    yield put(failureDeleteVideoUpload(error));
  }
}
